
import React, { useState ,useEffect} from "react";
import {loaderBar ,  apibaseURl ,  changeDateFotmate, currencySymbol , loggedInUserDetails , loggedInCustomerDetails } from '../../functions/Function';
const  Wallethistory = (props) => {
    const [data, setData] = useState({});
    const [isLoading, setisLoading] = useState(true);
    const fetchData = () => {
      fetch(apibaseURl + "wallethistory/"+loggedInCustomerDetails('id'))
        .then(res => res.json())
        .then((result) => {
          if (result.result == true) {
              setisLoading(false);
              setData(result.response);
            }
        }
        )
    } 
  
    useEffect(() => {
      fetchData();
     }, [])
  return (
    <>
       <div className="tab-pane show fade active">
        <div className="balance-tab-content transaction-history">
            <div className="trade-one-table-box trade-shadow-box">
                <table className="table table-borderless final-table mb-0 ivo-table-responsive">
                <thead>
                    <tr className="trade-tablke-header">
                        <th scope="col">Description</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Type</th>
                        <th scope="col">Status</th>
                        <th scope="col">Date</th>
                    </tr>
                </thead>
                <tbody>
                {isLoading == true && 
                    <tr>
                        <td colSpan={5} className="text-center data-not-found">{loaderBar(100 , 25)}</td>
                    </tr>
                }
                    {isLoading == false &&
                    <>
                        { Object.keys(data).length > 0  ? data.map((row, i) => (
                        <tr className="final-table-tr">
                            <td data-label="Description" className="final-table-heading">
                                <h6>{row.description.toUpperCase() }</h6>
                            </td>
                            <td data-label="Amount">  {currencySymbol()} {row.type == '0' &&  '-' }{row.wallet}</td>
                            <td className="color-green" data-label="TYPE">
                                {row.type == '1' &&  <span>Deposit </span> }
                                {row.type == '0' &&  <span>Wihtdraw </span> }
                            </td>
                            <td  data-label="Status" className="color-green">
                                {<span>Success</span> }
                                
                            </td>
                            <td data-label="Time">{changeDateFotmate(row.created_date , 'MMMM Do YYYY, h:mm:ss a')}</td>
                        </tr>
                        ))
                        : 
                        <tr>
                              <td colSpan={5} className="text-center data-not-found">Data Not Found</td>
                        </tr>
                        }
                    </>
                    }
                    
                </tbody>
                </table>
            </div>
        </div>
    </div>       
    </>

  );
}

export default Wallethistory;
